<template>
  <v-app>
    <LivelapsPublicHeader />
    <v-container>
      <v-card
        v-if="isValid"
        class="mx-auto titleHeading"
        style="max-width: 500px; text-align: center;"
      >
        <v-list-item-title class="headline2 font-weight-bold" >
          {{ $t("layouts.login.reset-password") }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="forgot_password">
          {{ $t("layouts.login.security-reason") }}
        </v-list-item-subtitle>
      </v-card>
      <v-card v-if="isValid" class="mx-auto" style="max-width: 500px;">
        <v-form ref="form" v-model="form" class="pa-4 pt-6">
          <v-text-field
            v-model="new_password"
            filled
            :label="$tc('layouts.login.new-password')"
            style="min-height: 96px"
            autocomplete="off"
            :type="show2 ? 'text' : 'password'"
            :append-icon="show2 ? 'fa-eye' : 'fa-eye-slash'"
            :error-messages="new_passwordErrors"
            @blur="$v.new_password.$touch()"
            @click:append="show2 = !show2"
          ></v-text-field>
          <v-text-field
            v-model="verifyPassword"
            filled
            autocomplete="off"
            :label="$tc('layouts.login.verify-password')"
            style="min-height: 96px"
            :type="show3 ? 'text' : 'password'"
            :append-icon="show3 ? 'fa-eye' : 'fa-eye-slash'"
            :error-messages="passwordVerifyErrors"
            @click:append="show3 = !show3"
          ></v-text-field>
        </v-form>
        <v-list-item-subtitle
          v-if="wrong_password"
          style="text-align: center; color: red;"
        >{{ $t("layouts.login.wrong-password") }}</v-list-item-subtitle>
        <v-list-item-subtitle
          v-if="success"
          style="text-align: center; color: green; padding: 0px 50px; white-space: none;"
        >
          {{ $t("layouts.login.success-change-password") }}
          <a
            href="#"
            @click="link()"
          >{{ $t("layouts.login.go") }}</a>
        </v-list-item-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
            @click="submit"
          >{{ $t("layouts.login.reset-password") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        v-if="invalid_access"
        class="mx-auto titleHeading"
        style="max-width: 100%; text-align: center;"
      >
        <v-list-item-title class="headline2 font-weight-bold">
          <v-icon>fa far fa-lock</v-icon>
          {{ $t("layouts.login.invalid-access") }}
        </v-list-item-title>
      </v-card>

      <v-card
        v-if="token_expired"
        class="mx-auto titleHeading"
        style="max-width: 100%; text-align: center;"
      >
        <v-icon>fa far fa-lock</v-icon>
        <v-list-item-title
          class="headline2 font-weight-bold"
          v-html="$tc('layouts.login.token-expired')"
        >{{ $t("layouts.login.token-expired") }}</v-list-item-title>
        <router-link :to="{ name: 'Login' }">{{ $t("layouts.login.token-reset-link") }}</router-link>
      </v-card>

      <v-card
        v-if="token_reset"
        class="mx-auto titleHeading"
        style="max-width: 100%; text-align: center;"
      >
        <v-icon>fa far fa-lock</v-icon>
        <v-list-item-title
          class="headline2 font-weight-bold"
          v-html="$tc('layouts.login.token-reset')"
        >{{ $t("layouts.login.token-reset") }}</v-list-item-title>
        <router-link :to="{ name: 'Login' }">{{ $t("layouts.login.token-reset-link") }}</router-link>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import LoginService from "../services/LoginService";
import LivelapsPublicHeader from "@/components/layouts/LivelapsPublicHeader.vue";
import { VApp, VContainer, VCard, VListItemTitle, VIcon, VListItemSubtitle,
         VBtn, VForm, VTextField, VCardActions, VDivider, VSpacer } from 'vuetify/lib';
import { mapState } from 'vuex';

export default {
  mixins: [validationMixin],
  components: {
    LivelapsPublicHeader,
    VApp, VContainer, VCard, VListItemTitle, VIcon, VListItemSubtitle,
    VBtn, VForm, VTextField, VCardActions, VDivider, VSpacer
  },
  validations: {
    new_password: {
      required,
      maxLength: value => !value || new TextEncoder().encode(value).length <= 72,
      minLength: minLength(8)
    },
    verifyPassword: {
      sameAsPassword: sameAs("new_password")
    }
  },
  data: () => ({
    form: false,
    new_password: "",
    verifyPassword: "",
    show2: false,
    show3: false,
    invalid_access: false,
    token_expired: false,
    token_reset: false,
    isValid: false,
    userId: null,
    wrong_password: false,
    success: false,
    forgot_password: true
  }),
  computed: {
    ...mapState({
      urlLivelaps: (state) => state.env.get('VUE_APP_LIVELAPS_HOST'),
    }),
    new_passwordErrors() {
      const errors = [];
      if (!this.$v.new_password.$dirty) return errors;

      !this.$v.new_password.required && errors.push(this.$t("common.password_required"));

      !this.$v.new_password.maxLength &&
        errors.push(this.$t("common.password_max_length"));

      !this.$v.new_password.minLength &&
        errors.push(this.$t("common.password_min_length"));

      return errors;
    },
    passwordVerifyErrors() {
      const errors = [];
      if (!this.$v.new_password.$dirty) return errors;

      !this.$v.verifyPassword.sameAsPassword &&
        errors.push(this.$t("common.verify_password"));
      return errors;
    }
  },
  methods: {
    link() {
      this.$router.push({ name: 'Login' });
    },
    async submit() {
      this.wrong_password = false;

      this.$v.$touch();

      if(this.forgot_password){
        if (this.$v.$invalid) {
          return;
        }
      } else{
        if (this.$v.verifyPassword.$invalid || this.$v.new_password.$invalid) {
          return;
        }
      }

      let data = { new_password: this.new_password,
                   userId: this.userId,
                   token: this.$route.query.token };

      LoginService.resetPassword(data).then(response => {
        if (response.data.message == "wrong_password") {
          this.wrong_password = true;
        } else {
          this.success = true;
        }
      });
    }
  },
  created: function() {
    if (typeof this.$route.query.token === "undefined") {
      this.invalid_access = true;
    } else {
      const data = {
        token: this.$route.query.token
      };

      LoginService.decryptToken(data).then(response => {

        if (response.data.message == "reset_your_password_has_expired") {
          this.token_expired = true;
        } else if( response.data.message == "already_reset"){
          this.token_reset = true;
        } else {
          this.userId = response.data.message.userId;
          this.forgot_password = response.data.message.forgot_password;
          this.isValid = true;
        }
      });
    }
  }
};
</script>
<style>
.v-application .headline2 {
  font-size: 24px !important;
  color: #5a5a5a !important;
}
.titleHeading {
  box-shadow: 0px 0px 0px 0px !important;
  margin-bottom: 15px;
}
.v-list-item__title,
.v-list-item__subtitle {
  white-space: pre-line !important;
}
</style>
